import { gql } from 'graphql-request';
import { request } from '../graphql';

const GET_COMPANY_DASHBOARDS = gql`
  query getCompany($id:String!) {
    company(id:$id) {
      _id
      homeDashboard
      realTimeSequenceOfDashboard {
        dashboardTabs {
          dashboardId
          title
          order
          addBelowFive5Plot
          suveyFor5APlot {
            _id
          }
        }
      }
      dashboards {
        _id
        order
        title
        reckonings {
          _id
          endDate
        }
        sequenceOfDashboard {
          title
          tagColor
          tagName
          dashboardTabs {
            dashboardId
            title
            order
            addBelowFive5Plot
            suveyFor5APlot {
              _id
            }
          }
        }
      }
      realTimeDashboardSummary
      realTimeDashboardUsage
      realTimeDashboardFeature
      realTimeDashboardSegment
    }
  }
`;
export type GetCompanyDashboardsData = {
  company: {
    _id: string;
    homeDashboard: string;
    realTimeSequenceOfDashboard: {
      dashboardTabs: {
        dashboardId: string;
        title: string;
        order: number;
        addBelowFive5Plot?: boolean;
          suveyFor5APlot?: {
           _id: string;
          };
      }[]
    }
    dashboards: {
      _id: string;
      order: number;
      title: string;
      reckonings: {
        _id: string;
        endDate: string,
      }[]
      sequenceOfDashboard: {
        tagColor: string;
        tagName: string;
        title: string;
        dashboardTabs: {
          dashboardId: string;
          title: string;
          order: number;
          addBelowFive5Plot?: boolean;
          suveyFor5APlot?: {
           _id: string;
          };
        }[]
      }
    }[]
  }
}

export const getCompanyDashboards = (id: string, language: string) => request<GetCompanyDashboardsData>(GET_COMPANY_DASHBOARDS, {
  id
}, language);